// Additional Parse functions

/**
 * Object to JSON with nested attributes
 *
 * @param {Object} object
 * @returns {*}
 */
function toJSON(object) {
    var json = _toFullJSON(object);
    Parse._arrayEach(['__type', 'className'],
        function(key) { delete json[key]; });
    return json;
}

function _toFullJSON(object) {
    var json = _.clone(object.attributes);
    Parse._objectEach(json, function(val, key) {
        json[key] = Parse._encode(val, []);
    });
    Parse._objectEach(object._operations, function(val, key) {
        json[key] = val;
    });

    if (_.has(object, 'id')) {
        json.objectId = object.id;
    }
    if (_.has(object, 'createdAt')) {
        if (_.isDate(object.createdAt)) {
            json.createdAt = object.createdAt.toJSON();
        } else {
            json.createdAt = object.createdAt;
        }
    }

    if (_.has(object, 'updatedAt')) {
        if (_.isDate(object.updatedAt)) {
            json.updatedAt = object.updatedAt.toJSON();
        } else {
            json.updatedAt = object.updatedAt;
        }
    }
    json.__type = 'Object';
    json.className = object.className;
    return json;
}

module.exports = {
    toJSON: toJSON
};




// WEBPACK FOOTER //
// ./app/helpers/parseUtil.js